import facebookIcon from '../assets/images/icons-social/facebook-icon.png'
import instagramIcon from '../assets/images/icons-social/instagram-icon.png'
import linkedinIcon from '../assets/images/icons-social/linkedin-icon.png'
import tiktokIcon from '../assets/images/icons-social/tiktok-icon.png'
import youtubeIcon from '../assets/images/icons-social/youtube-icon.png'
import aoladoIcon from '../assets/images/icons-social/aolado-icon.png'

export default function Footer() {
    return (
        <footer className="footer-v3 relative overflow-hidden" role="contentinfo">
            <div className="absolute inset-0 bg-gradient-to-br from-brand-600/10 via-transparent to-purple-600/10 pointer-events-none" />
            <div className="footer-v3-container relative">
                <div className="footer-v3-main-content">
                    {/* Left Column: Logo + Copyright */}
                    <div className="footer-v3-left">
                        <div className="footer-v3-logo-container">
                            <a href="https://apav.pt" target="_blank" rel="noopener noreferrer">
                                <img
                                    src="/assets/images/combinadohorizontal.svg"
                                    alt="APAV Apoio à Vítima - 116 006"
                                    className="footer-v3-logo-group hover:opacity-90 transition-opacity"
                                />
                            </a>
                        </div>
                        <p className="footer-v3-copyright">© Copyright APAV - Todos os Direitos Reservados</p>
                    </div>

                    {/* Middle Column: Vertical Links */}
                    <div className="footer-v3-middle">
                        <nav className="footer-v3-links">
                            <a href="https://apav.pt/" target="_blank" rel="noopener noreferrer">APAV.PT</a>
                            <a href="https://apav.pt/preciso-de-ajuda/" target="_blank" rel="noopener noreferrer">Preciso de Ajuda</a>
                            <a href="https://apav.pt/contactos/" target="_blank" rel="noopener noreferrer">Contactos | Onde Estamos</a>
                            <a href="https://apav.pt/politica-de-privacidade/" target="_blank" rel="noopener noreferrer">Política de Privacidade</a>
                        </nav>
                    </div>

                    {/* Right Column: Social Icons */}
                    <div className="footer-v3-right">
                        <div className="footer-v3-social-grid">
                            <a href="https://www.facebook.com/APAV.Portugal/" target="_blank" rel="noopener noreferrer" className="v3-social-box" aria-label="Facebook">
                                <img src={facebookIcon} alt="Facebook" />
                            </a>
                            <a href="https://www.instagram.com/apav_online/" target="_blank" rel="noopener noreferrer" className="v3-social-box" aria-label="Instagram">
                                <img src={instagramIcon} alt="Instagram" />
                            </a>
                            <a href="https://www.linkedin.com/company/apav/?originalSubdomain=pt" target="_blank" rel="noopener noreferrer" className="v3-social-box" aria-label="LinkedIn">
                                <img src={linkedinIcon} alt="LinkedIn" />
                            </a>
                            <a href="https://www.tiktok.com/@apav_online" target="_blank" rel="noopener noreferrer" className="v3-social-box" aria-label="TikTok">
                                <img src={tiktokIcon} alt="TikTok" />
                            </a>
                            <a href="https://www.youtube.com/APAVportugal" target="_blank" rel="noopener noreferrer" className="v3-social-box" aria-label="YouTube">
                                <img src={youtubeIcon} alt="YouTube" />
                            </a>
                            <a href="https://bsky.app/profile/apav-online.bsky.social" target="_blank" rel="noopener noreferrer" className="v3-social-box" aria-label="Bluesky">
                                <svg viewBox="0 0 24 24" fill="#fff" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 10.8c-1.087-2.114-4.046-6.053-6.798-7.995C2.566.944 1.561 1.266.902 1.565.139 1.908 0 3.08 0 3.768c0 .69.378 5.65.624 6.479.815 2.736 3.713 3.66 6.383 3.364.136-.02.275-.039.415-.056-.138.022-.276.04-.415.056-3.911.58-7.386 2.005-2.83 7.078 5.013 5.19 6.87-1.113 7.823-4.308.953 3.195 2.05 9.271 7.733 4.308 4.267-4.308 1.172-6.498-2.74-7.078a8.741 8.741 0 0 1-.415-.056c.14.017.279.036.415.056 2.67.297 5.568-.628 6.383-3.364.246-.828.624-5.79.624-6.478 0-.69-.139-1.861-.902-2.206-.659-.298-1.664-.62-4.3 1.24C16.046 4.748 13.087 8.687 12 10.8Z" />
                                </svg>
                            </a>
                            <a href="https://aoladodasvitimas.apav.pt" target="_blank" rel="noopener noreferrer" className="v3-social-box" aria-label="Ao Lado das Vítimas">
                                <img src={aoladoIcon} alt="Ao Lado das Vítimas" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
